import { render, staticRenderFns } from "./HappyCustomer.vue?vue&type=template&id=45acad81&scoped=true"
import script from "./HappyCustomer.vue?vue&type=script&lang=js"
export * from "./HappyCustomer.vue?vue&type=script&lang=js"
import style0 from "./HappyCustomer.vue?vue&type=style&index=0&id=45acad81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45acad81",
  null
  
)

export default component.exports